import type { ConflictBandProps } from "./types-conflict-band";
import { useConflictBand } from "./use-conflict-band";
import { ConflictBandView } from "./view-conflict-band";

/** Faixa laranja do trecho em conflito; ao passar o mouse/focar mostra o card com as obras e datas. */
export function ConflictBand(props: ConflictBandProps) {
  const vm = useConflictBand(props);

  return <ConflictBandView {...vm} />;
}

export type * from "./types-conflict-band";
